var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStep6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.293 3.5303L10.8299 0.0623299C10.9403 0.0221922 11.0613 0.0221921 11.1717 0.0623298L20.7086 3.5303C21.1474 3.68988 21.1474 4.31051 20.7086 4.47009L11.1717 7.93806C11.0613 7.9782 10.9403 7.9782 10.8299 7.93806L1.293 4.47009C0.854158 4.31051 0.854157 3.68988 1.293 3.5303Z",
    fill: "#0F973D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59112 6.9673L1.293 8.53026C0.854157 8.68983 0.854158 9.31047 1.293 9.47005L10.8299 12.938C10.9403 12.9782 11.0613 12.9782 11.1717 12.938L20.7086 9.47005C21.1474 9.31047 21.1474 8.68983 20.7086 8.53026L16.4104 6.96729L11.205 8.96227C11.0731 9.01285 10.9284 9.01285 10.7964 8.96227L5.59112 6.9673Z",
    fill: "#0F973D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.293 12.5303L4.25237 11.4541L10.7964 13.9622C10.9284 14.0127 11.0731 14.0127 11.205 13.9622L17.7491 11.4541L20.7086 12.5303C21.1474 12.6898 21.1474 13.3105 20.7086 13.47L11.1717 16.938C11.0613 16.9782 10.9403 16.9782 10.8299 16.938L1.293 13.4701C0.854158 13.3105 0.854157 12.6898 1.293 12.5303Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStep6);
export default __webpack_public_path__ + "static/media/ic_step6.b51acf0bf324e47f4facfa7e8ee0701b.svg";
export { ForwardRef as ReactComponent };